import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackageSixUpImagesIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryPackageSixUpImagesIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
